module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('footer', {
    staticClass: "footer"
  }, [_c('nav', {
    staticClass: "navbar navbar-expand navbar-dark"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row w-100"
  }, [_c('div', {
    staticClass: "col-sm-2"
  }, [_c('router-link', {
    staticClass: "nav-link",
    attrs: {
      "active-class": "active",
      "to": "/"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.collapseMenu($event)
      }
    }
  }, [_c('img', {
    attrs: {
      "src": require("assets/img/logo.png")
    }
  })])], 1), _vm._v(" "), _c('div', {
    staticClass: "col-sm-10"
  }, [_c('div', {
    staticClass: "collapse navbar-collapse",
    attrs: {
      "id": "navbarSupportedContent"
    }
  }, [_c('ul', {
    staticClass: "ml-auto mt-4 mt-md-0 navbar-nav"
  }, [_c('li', {
    staticClass: "nav-item mr-3"
  }, [_c('router-link', {
    staticClass: "nav-link",
    attrs: {
      "to": "/about"
    }
  }, [_vm._v("Sobre")])], 1), _vm._v(" "), _c('li', {
    staticClass: "nav-item mr-3"
  }, [_c('router-link', {
    staticClass: "nav-link",
    attrs: {
      "to": "/faq"
    }
  }, [_vm._v("FAQ")])], 1), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('li', {
    staticClass: "nav-item mr-3"
  }, [_c('router-link', {
    staticClass: "nav-link",
    attrs: {
      "to": "/terms"
    }
  }, [_vm._v("Termos de uso e Politica de Privacidade")])], 1)])])])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', {
    staticClass: "nav-item mr-3"
  }, [_c('a', {
    staticClass: "nav-link",
    attrs: {
      "href": "https://forms.gle/2XeYcZQPLE5muko87",
      "target": "_blank"
    }
  }, [_vm._v("Contato")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-618e1444","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/PageFooter.vue
// module id = 353
// module chunks = 1